//css-------------------
import '../../css/share/common.scss';
import '../../css/home/article_content.scss';

//fontawesome
import( /* webpackPrefetch: true */ '../../lib/fontawesome/fontawesome.scss');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/regular.scss');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/brands.scss');

//js----------------------
//components
import( /* webpackPrefetch: true */ '../share/components/_header');
import( /* webpackPrefetch: true */ '../share/components/_cookie_bar');
import( /* webpackPrefetch: true */ '../share/components/_font_family');
import( /* webpackPrefetch: true */ '../share/components/_font_size');

//npm lib
import $ from "jquery";
import imagesLoaded from "imagesloaded";
import { createApp } from 'vue/dist/vue.esm-browser.prod.js';

$(function() {

    const app = createApp({
        data() {
            return {

            }
        },
        mounted() {

            imagesLoaded("html, body", function() {
                $(".loading").fadeOut(function() {
                    $(this).remove();
                });
            });
        },
        methods: {},
    }).mount('#app');


});